export const NO_TAX = {
  name: 'Sin impuestos',
  id: '3',
  value: 1,
}

export const TAX_IVA = {
  name: 'IVA',
  id: '2',
  value: 1.21,
}

export const IGIC_IVA = {
  name: 'IGIC (Canarias)',
  id: '1',
  value: 1.07,
}

export const IPSI_CEUTA = {
  name: 'IPSI (Ceuta)',
  id: '3',
  value: 1.1,
}

export const IPSI_MELILLA = {
  name: 'IPSI (Melilla)',
  id: '4',
  value: 1.08,
}

export const taxList = [NO_TAX, TAX_IVA, IGIC_IVA, IPSI_CEUTA, IPSI_MELILLA]
